(function () {
  'use strict';

  function formatBundleMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format).replace('.00', '');
    }

    var amount = (Number(cents || 0) / 100).toFixed(2);
    var format = window.money_format || '{{amount}}';
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(Number(amount)).toString())
      .replace('.00', '');
  }

  function getRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  async function getCart() {
    var response = await fetch(getRoot() + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  function updateCartMeta(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });

    document.querySelectorAll('[data-bundle-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });

    document.querySelectorAll('[data-bundle-cart-count-label]').forEach(function (label) {
      label.textContent = cart.item_count === 1 ? 'item' : 'items';
    });

    document.querySelectorAll('[data-bundle-cart-total], [data-cart-total]').forEach(function (total) {
      total.textContent = formatBundleMoney(cart.total_price);
    });

    if (window.FreeShippingBar && typeof window.FreeShippingBar.update === 'function') {
      window.FreeShippingBar.update(cart.total_price);
    }
  }

  async function refreshBundleCart(builder) {
    var sectionId = builder.dataset.sectionId;
    if (!sectionId) return;

    var separator = window.location.search ? '&' : '?';
    var response = await fetch(window.location.pathname + window.location.search + separator + 'section_id=' + encodeURIComponent(sectionId));
    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextBuilder = doc.querySelector('[data-bundle-builder]');
    if (!nextBuilder) return;

    var nextItems = nextBuilder.querySelector('[data-bundle-cart-items]');
    var currentItems = builder.querySelector('[data-bundle-cart-items]');
    var nextFooter = nextBuilder.querySelector('[data-bundle-cart-footer]');
    var currentFooter = builder.querySelector('[data-bundle-cart-footer]');

    if (nextItems && currentItems) currentItems.innerHTML = nextItems.innerHTML;
    if (nextFooter && currentFooter) currentFooter.innerHTML = nextFooter.innerHTML;
  }

  async function refreshSlideCart() {
    var drawer = document.getElementById('slideCart');
    if (!drawer) return;

    try {
      var response = await fetch('/?section_id=template-slide-out-cart');
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextItems = doc.querySelector('[data-cart-items]');
      var currentItems = drawer.querySelector('[data-cart-items]');
      var nextFooter = doc.querySelector('.slide-cart__footer');
      var currentFooter = drawer.querySelector('.slide-cart__footer');

      if (nextItems && currentItems) currentItems.innerHTML = nextItems.innerHTML;
      if (nextFooter && currentFooter) currentFooter.innerHTML = nextFooter.innerHTML;
    } catch (error) {
      console.error('Slide cart refresh failed:', error);
    }
  }

  async function refreshCarts(builder) {
    var cart = await getCart();
    updateCartMeta(cart);

    try {
      await refreshBundleCart(builder);
    } catch (error) {
      console.error('Bundle cart refresh failed:', error);
    }

    await refreshSlideCart();

    return cart;
  }

  function initBundleBuilder(builder) {
    var tabButtons = builder.querySelectorAll('[data-bundle-tab]');
    var panels = builder.querySelectorAll('[data-bundle-panel]');
    var cartPanel = builder.querySelector('[data-bundle-cart]');
    var cartToggle = builder.querySelector('[data-bundle-cart-toggle]');
    var errorElement = builder.querySelector('[data-bundle-error]');

    function showError(message) {
      if (!errorElement) return;
      errorElement.textContent = message;
      errorElement.hidden = !message;
    }

    function activateTab(tabName) {
      tabButtons.forEach(function (button) {
        var isActive = button.dataset.bundleTab === tabName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.bundlePanel === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button.dataset.bundleTab);
      });
    });

    builder.querySelectorAll('[data-bundle-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var card = select.closest('[data-bundle-product-card]');
        var button = card.querySelector('[data-bundle-add]');
        var price = card.querySelector('[data-bundle-card-price]');
        var available = option.dataset.available === 'true';

        button.dataset.variantId = option.value;
        button.dataset.price = option.dataset.price;
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : 'Sold out';

        if (price) price.textContent = formatBundleMoney(Number(option.dataset.price));
      });
    });

    builder.addEventListener('click', async function (event) {
      var addButton = event.target.closest('[data-bundle-add]');
      var cartQuantityButton = event.target.closest('[data-quantity-change]');

      if (addButton) {
        event.preventDefault();

        var originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        showError('');

        try {
          var response = await fetch(getRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(addButton.dataset.variantId),
                quantity: 1
              }]
            })
          });

          var responseData = await response.json().catch(function () {
            return {};
          });

          if (!response.ok) {
            throw new Error(responseData.description || responseData.message || 'There was a problem adding this item.');
          }

          await refreshCarts(builder);

          if (cartPanel && window.matchMedia('(max-width: 768px)').matches) {
            cartPanel.classList.add('is-open');
            cartToggle.setAttribute('aria-expanded', 'true');
          }
        } catch (error) {
          showError(error.message || 'There was a problem adding this item.');
        } finally {
          addButton.textContent = originalText;
          addButton.disabled = false;
        }
      }

      if (cartQuantityButton && builder.contains(cartQuantityButton)) {
        window.setTimeout(function () {
          refreshCarts(builder).catch(function (error) {
            console.error('Bundle cart quantity refresh failed:', error);
          });
        }, 650);
      }
    });

    builder.addEventListener('change', function (event) {
      if (!event.target.matches('[data-quantity-input]')) return;

      window.setTimeout(function () {
        refreshCarts(builder).catch(function (error) {
          console.error('Bundle cart input refresh failed:', error);
        });
      }, 650);
    });

    if (cartToggle && cartPanel) {
      cartToggle.addEventListener('click', function () {
        var isOpen = cartPanel.classList.toggle('is-open');
        cartToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  });
})();
